import { Checkbox } from "@mantine/core";
import { useDispatch, useSelector } from "src/redux/hooks";
import { setSelectAll } from "src/redux/slices/managementSlice";

const SelectAllCheckbox = () => {
  const dispatch = useDispatch();
  const { selectAll } = useSelector(state => state.managementSlice);

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Checkbox
        checked={selectAll}
        onChange={() => dispatch(setSelectAll(!selectAll))}
        style={{ margin: "0 auto" }}
      />
    </div>
  );
};
export default SelectAllCheckbox;
